{
  "profile": "Profil",
  "nbOfUsers": "Anzahl der Benutzer",
  "validation": {
    "name": "Profilname ist erforderlich",
    "maxLength": "Name darf maximal 50 Zeichen lang sein"
  },
  "roles": "Rollen",
  "name": "Profilname",
  "empty": "Keine Rollen verfügbar",
  "confirmDelete": {
    "title": "Profil entfernen",
    "description": "Das ausgewählte Profil „{userProfileName}“ wird entfernt."
  },
  "cannotDelete": {
    "title": "Das Profil kann nicht entfernt werden",
    "description": "Das ausgewählte Profil „{userProfileName}“ ist mit {usersCount} Benutzern verknüpft."
  },
  "button": {
    "delete": "Profil löschen"
  },
  "identity": "Identität",
  "new": "Neues Profil",
  "label": {
    "administrator": "Administrator"
  }
}
